class FiltersConverterService {
  static converters = {
    radioConverter: {
      parse: (string, filter) => {
        const option = filter.options.find((xxx) => xxx.key === string);

        return option.key;
      },
      stringify: (option, filter) => {
        const slugs = [];

        const filterOption = filter.options.find((xxx) => xxx.key === option);

        if (filterOption) {
          slugs.push(filterOption.key);
        }

        return slugs.join(",");
      },
    },
    textConverter: {
      parse: (string) => string,
      stringify: (string) => string,
    },
  };

  static stringify = (values, filters, filterConverters) => {
    const parts = [];

    Object.keys(values).forEach((key) => {
      const filter = filters.find((xxx) => xxx.key === key);

      const { key: filterKey } = filter;

      const value = filterConverters[key].stringify(values[key], filter);

      if (filterKey && value) {
        parts.push(`${filterKey}:${value}`);
      }
    });

    return parts.join("/") || "";
  };

  static parse = (string, filters, filterConverters) => {
    const parts = string.split("/");
    const object = {};

    parts.forEach((part) => {
      const slug = part.split(":")[0];
      const valueAsString = part.split(":")[1];

      if (slug && valueAsString) {
        const filter = filters.find((yyy) => yyy.key === slug);

        const { key } = filter;
        const value = filterConverters[key].parse(valueAsString, filter);

        object[key] = value;
      }
    }, {});

    return object;
  };
}

export default FiltersConverterService;
